<template>
    <div class="modulecreator">
        <div class="modulecreator__head">
            <h1>
                <span v-html="$helpers.uiText('U015')"></span>
                <img
                    v-tooltip="$helpers.uiText('U017')"
                    v-bind:src="generateMediaUrl({ path: 'static/ui/misc/help.svg' })"
                    class="help-icon"
                    width="20"
                    alt=""
                />
            </h1>
            <p
                class="modulecreator__intro"
                v-html="$helpers.uiText('U016').replace('%PAGE%', getActivePageName)"
            ></p>
        </div>
        <div class="modulecreator__body">
            <div class="modulecreator__row" v-if="getPossibleSmartModulesToCreate">
                <div class="modulecreator__group-title">
                    Smarte Module
                </div>
                <ul class="modulecreator__modules">
                    <li
                        v-for="(modules__value, modules__key) in getPossibleModulesToCreate"
                        v-if="modules__value.group === 'smart'"
                        :key="modules__key"
                        :class="'icon--' + modules__value.type"
                        class="modulecreator__module"
                    >
                        <a
                            v-on:click.prevent="
                                createModule({
                                    type: modules__value.type,
                                    name: modules__value.name,
                                    insertAfter: getModulecreatorInsertAfter,
                                    route: true
                                })
                            "
                            href="#"
                            class="modulecreator__module-link"
                            v-tooltip="modules__value.createHelp()"
                        >
                            <div
                                v-bind:style="{
                                    backgroundImage:
                                        'url(' +
                                        generateMediaUrl({
                                            path:
                                                'static/modulecreator/' +
                                                modules__value.type +
                                                '.svg'
                                        }) +
                                        ')'
                                }"
                                class="modulecreator__module-image modulecreator__module-image--smart"
                            />
                            {{ modules__value.name }}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="modulecreator__row" v-if="getPossibleFlexibleModulesToCreate">
                <div class="modulecreator__group-title">
                    Flexible Module
                </div>
                <ul class="modulecreator__modules">
                    <li
                        v-for="(modules__value, modules__key) in getPossibleModulesToCreate"
                        v-if="modules__value.group === 'flexible'"
                        :key="modules__key"
                        :class="'icon--' + modules__value.type"
                        class="modulecreator__module"
                    >
                        <a
                            v-on:click.prevent="
                                createModule({
                                    type: modules__value.type,
                                    name: modules__value.name,
                                    insertAfter: getModulecreatorInsertAfter,
                                    route: true
                                })
                            "
                            href="#"
                            class="modulecreator__module-link"
                            v-tooltip="modules__value.createHelp()"
                        >
                            <div
                                v-bind:style="{
                                    backgroundImage:
                                        'url(' +
                                        generateMediaUrl({
                                            path:
                                                'static/modulecreator/' +
                                                modules__value.type +
                                                '.svg'
                                        }) +
                                        ')'
                                }"
                                class="modulecreator__module-image modulecreator__module-image--flexible"
                            />
                            {{ modules__value.name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <a v-on:click.prevent="closeModulecreator" href="#" class="modulecreator__close"
            >schließen</a
        >
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {
        ...mapActions(['closeModulecreator', 'createModule'])
    },
    computed: {
        ...mapGetters([
            'getPossibleModulesToCreate',
            'getModulecreatorInsertAfter',
            'getActivePageName',
            'generateMediaUrl',
            'hasPackageBasic'
        ]),
        getPossibleSmartModulesToCreate() {
            return (
                this.getPossibleModulesToCreate.filter((e) => {
                    return e.group === 'smart';
                }).length > 0
            );
        },
        getPossibleFlexibleModulesToCreate() {
            return (
                this.getPossibleModulesToCreate.filter((e) => {
                    return e.group === 'flexible';
                }).length > 0
            );
        }
    },
    created() {},
    watch: {},
    props: {}
};
</script>
